var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-2",attrs:{"icon":"","small":"","color":"primary"},on:{"click":_vm.openInstructionCategoryCreate}},[_c('v-icon',[_vm._v("mdi-plus")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }